import { render, staticRenderFns } from "./AddReserve.vue?vue&type=template&id=58e88582&"
import script from "./AddReserve.vue?vue&type=script&lang=js&"
export * from "./AddReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports